
/* injects from baggage-loader */

export const getSwarmSubscriptionRequestGameMarketsList = gameId => {
	return {
		source: "betting",
		what: {
			sport: ["id", "name", "alias"],
			region: ["id", "name"],
			competition: ["id", "name"],
			game: [],
			market: [
				"name",
				"type",
				"id",
				"market_type",
				"order",
				"col_count",
				"is_new",
				"express_id",
				"cashout",
				"base",
				"group_id",
				"group_name",
				"display_key",
				"home_score",
				"away_score",
				"main_order",
				"optimal",
				"has_early_payout",
			],
			event: ["id", "order", "name", "price", "type", "base"],
		},
		where: {
			game: { id: +gameId },
		},
	};
};
